<template lang="html">
    <div class="detail">
        <common-header></common-header>
        <div class="page" style="margin: 0;padding: 0;">
            <div class="table-body">

                <div style="text-align: center;">
                    <h4>{{ formData1.union }}</h4>
                    <div style="display: inline-flex; align-items: center; gap: 10px;">
                        <h3 style="letter-spacing: 15px; margin: 0;">会员登记表</h3>
                        <div class="btn btn-light print-hidden" @click="openFullDetail">查看完整信息</div>
                    </div>
                </div>
                <div style="text-align: right;width: 100%;">
                    <span style="margin-right: 200px;">编号:{{ formData1.memberid }}</span>
                </div>
                <table border="1">
                    <tr>
                        <td rowspan="5" style="width: 160px;height: 240px;overflow: hidden;">
                            <img v-if="formData1.photo" :src="formData1.photo" style="width: 100%;" />
                        </td>
                        <td style="width: 80px;">姓名</td>
                        <td style="width: 180px;">{{ formData1.name }}</td>
                        <td style="width: 80px;">笔名<br/>（艺名）</td>
                        <td style="width: 120px;">{{ formData1.penname }}</td>
                        <td style="width: 80px;">性别</td>
                        <td style="width: 120px;">{{ formData1.gender == 1 ? '男' : '女' }}</td>
                    </tr>
                    <tr>
                        <td>出生<br/>年月</td>
                        <td>{{ formData1.birthdate }}</td>
                        <td>民族</td>
                        <td>{{ formData1.nation }}</td>
                        <td>政治<br/>面貌</td>
                        <td>{{ formData1.political }}</td>
                    </tr>
                    <tr>
                        <td>文化<br/>程度</td>
                        <td>{{ formData1.education }}</td>
                        <td>籍贯</td>
                        <td>{{ formData1.birthplace }}</td>
                        <td>身份证号</td>
                        <td>{{ formData1.idnumber }}</td>
                    </tr>
                    <tr>
                        <td rowspan="2">工作<br/>单位</td>
                        <td rowspan="2">{{ formData1.employer }}</td>
                        <td style="height: 30px;">职务</td>
                        <td colspan="3" style="height: 30px;">{{ formData1.position }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px;">职称</td>
                        <td colspan="3" style="height: 30px;">{{ formData1.positiontitle }}</td>
                    </tr>
                </table>

                <table border="1" style="border-top: none;" v-if="formData1.status != '终审通过' && formData1.status != '初审通过'">
                    <tr style="border-top: none;">
                        <td style="width: 160px;height: 50px;border-top: none;">文化程度</td>
                        <td style="width: 260px;height: 50px;border-top: none;">{{ formData1.education }}</td>
                        <td style="width: 80px;height: 50px;border-top: none;">身份证号码</td>
                        <td style="width: 320px;height: 50px;border-top: none;">{{ formData1.idnumber }}</td>
                    </tr>
                </table>

                <table border="1" style="border-top: none;">
                    <tr style="border-top: none;">
                        <td style="width: 160px;height: 50px;border-top: none;">通讯<br/>地址</td>
                        <td style="width: 260px;height: 50px;border-top: none;">{{ formData1.address }}</td>
                        <td style="width: 80px;height: 50px;border-top: none;">邮编</td>
                        <td style="width: 320px;height: 50px;border-top: none;">{{ formData1.postcode }}</td>
                    </tr>
                </table>
                <table border="1" style="border-top: none;">
                    <tr style="border-top: none;">
                        <td style="width: 160px;border-top: none;" rowspan="2">联系<br/>方式</td>
                        <td style="width: 80px;height: 50px;border-top: none;">办公<br/>电话</td>
                        <td style="width: 180px;height: 50px;border-top: none;">{{ formData1.officephone }}</td>
                        <td style="width: 150px;height: 50px;border-top: none;">电子信箱或个人网页</td>
                        <td style="height: 50px;border-top: none;">{{ formData1.email }}</td>
                    </tr>
                    <tr style="border-top: none;">
                        <td style="height: 30px;width: 80px;border-top: none;">微信</td>
                        <td style="height: 30px;border-top: none;">{{ formData1.wechat }}</td>
                        <td style="height: 30px;width: 80px;border-top: none;">手机</td>
                        <td style="height: 30px;border-top: none;">{{ formData1.mobile }}</td>
                    </tr>
                </table>

                <!-- <table border="1" style="border-top: none;">
                    <tr style="border-top: none;">
                        <td style="width: 120px;border-top: none;" rowspan="2">联系方式</td>
                        <td style="width: 100px;border-top: none;">微信号</td>
                        <td style="border-top: none;">{{ formData1.wechat }}</td>
                    </tr>
                    <tr>
                        <td>手机号</td>
                        <td>{{ formData1.mobile }}</td>
                    </tr>
                </table> -->

                <table border="1" style="border-top: none;">
                    <tr style="border-top: none;">
                        <td style="width: 40px;border-top: none;writing-mode: vertical-lr;text-orientation: upright;"
                            rowspan="3">入 会 时 间</td>
                        <td style="width: 120px;height: 50px;border-top: none;">国家级会员</td>
                        <td style="height: 50px;border-top: none;">{{ formData1.joindate_n }}</td>
                        <td style="width: 40px;border-top: none;writing-mode: vertical-lr;text-orientation: upright;"
                            rowspan="3">协 会 职 务</td>
                        <td style="width: 120px;height: 50px;border-top: none;">国家级协会</td>
                        <td style="height: 50px;border-top: none;">{{ formData1.posi_n }}</td>
                    </tr>
                    <tr>
                        <td style="height: 50px;">省级会员</td>
                        <td style="height: 50px;">{{ formData1.joindate_p }}</td>
                        <td style="height: 50px;">省级协会</td>
                        <td style="height: 50px;">{{ formData1.posi_p }}</td>
                    </tr>
                    <tr>
                        <td style="height: 50px;">市级会员</td>
                        <td style="height: 50px;">{{ formData1.joindate_c }}</td>
                        <td style="height: 50px;">市级协会</td>
                        <td style="height: 50px;">{{ formData1.posi_c }}</td>
                    </tr>
                </table>
                <table border="1" style="border-top: none;">
                  <tr>
                      <td style="width: 80px;writing-mode: vertical-lr;text-orientation: upright;height: 320px;font-size: 13px;">
                          <span style="letter-spacing: 13px;">主要艺术成就及获奖情况</span><br>（请注明时间、地点、主办单位及著作出版社）
                      </td>
                      <td colspan="5">
                          <div
                              style="display: flex;flex-direction: column;width: 100%;text-align: left;padding: 10px;">
                              <span v-for="(row, index) in formData2.awards" :key="index">
                                  {{ row.date }} 在 {{ row.place }} 获得 {{ row.awards }}
                              </span>
                          </div>
                      </td>
                  </tr>
                </table>


                <table border="1" style="border-top: none;">
                    <tr style="border-top: none;">
                        <td style="width: 120px;height: 50px;border-top: none;">起止年月</td>
                        <td style="height: 50px;border-top: none;font-weight: bold;">主 要 经 历</td>
                    </tr>
                    <tr v-for="(row, index) in formData3" :key="index">
                        <td style="height: 35px;">{{ row.startdate }}至{{ row.enddate }}</td>
                        <td style="height: 35px;">{{ row.exp }}</td>
                    </tr>
                    <template v-if="formData3.length < 3">
                        <tr v-for="i in (3 - formData3.length)">
                            <td style="height: 35px;"></td>
                            <td style="height: 35px;"></td>
                        </tr>
                    </template>
                </table>

                <table border="1" style="border-top: none;">
                    <tr style="border-top: none;">
                        <td style="border-top: none;height: 100px;width: 50%;">
                            <div
                                style="width: 100%;height: 100%;text-align: left;position: relative;box-sizing: border-box;padding: 10px;">
                                <span>本单位组织意见</span>
                                <div
                                    style="position: absolute;bottom: 10px;right: 10px;display: flex;flex-direction: column;">
                                    <span>签字（盖章）</span>
                                    <span style="letter-spacing: 15px;">年月日</span>
                                </div>
                            </div>
                        </td>
                        <td style="border-top: none;text-align: left;width: 50%;">

                            <div
                                style="width: 100%;height: 100%;text-align: left;position: relative;box-sizing: border-box;padding: 10px;">
                                <span>介绍人意见</span>
                                <div
                                    style="position: absolute;bottom: 10px;right: 10px;display: flex;flex-direction: column;">
                                    <span>签字（盖章）</span>
                                    <span style="letter-spacing: 15px;">年月日</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="height: 100px;" colspan="2">

                            <div
                                style="width: 100%;height: 100%;text-align: left;position: relative;box-sizing: border-box;padding: 10px;">
                                <span>本会主席团意见</span>
                                <div
                                    style="position: absolute;bottom: 10px;right: 10px;display: flex;flex-direction: column;">
                                    <span>签字（盖章）</span>
                                    <span style="letter-spacing: 15px;">年月日</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>

                <table border="1" style="border-top: none;">
                    <tr style="border-top: none;">
                        <td style="border-top: none;width: 60px;height: 100px;writing-mode: vertical-lr;text-orientation: upright;letter-spacing: 15px;">备注</td>
                        <td style="border-top: none;"></td>
                    </tr>
                </table>

                <div class="print-tips">
                    <h5>打印须知</h5>
                    <p>1.请用A4纸正反面打印。</p>
                    <p>2.在本单位组织意见栏和介绍人栏内签字盖章。如无工作单位，可在街道或区县级文联、协会盖章。</p>
                </div>


            </div>
        </div>
        <div class="row justify-content-md-center buttons" style="margin-top: 20px;">
            <div class="form-group" style="margin: 0 auto;">
                <div class="btn btn-primary" @click="$router.push('/')">
                    返回
                </div>

                <div class="btn btn-primary" @click="doPrint"
                    v-if="formData1.status == '终审通过' || formData1.status == '初审通过'">
                    打印
                </div>
                <!-- <div class="btn btn-primary" @click="doPrint"
                    >
                    打印
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import commonHeader from './header.vue'
import stepSecond from './step2.vue'
import stepThird from './step3.vue'
import mapPicker from './map.vue'
export default {
    components: {
        commonHeader,
        mapPicker,
        stepSecond,
        stepThird,
    },
    data() {
        return {
            formData1: '',
            formData2: [],
            formData3: []
        }
    },
    methods: {
        doPrint() {
            window.print()
        },
        openFullDetail() {
            const id = this.$route.query.id
            const routeData = this.$router.resolve({ path: '/detail', query: { id } })
            window.open(routeData.href, '_blank')
        },
        checkTime(time) {
            let date = new Date(time)
            if (date.getTime()) {
                return time
            } else {
                return ''
            }
        }
    },
    mounted() {
        let id = this.$route.query.id
        this.$axios.get('/api/wenlian/requestdetail', {
            params: {
                id: id,
                step: 1
            }
        }).then(res => {
            if (res.data.result == 1) {
                this.formData1 = res.data.data
            }
            // else {
            //   this.formData1 = { "id": "4359", "userid": "81", "name": "\u67f4\u4eac\u6b63", "pinyin": "chaijingzheng", "penname": "\u7af9\u5f71\u62c2\u5c18", "gender": "1", "birthdate": "1971-11-01", "nation": "\u6c49\u65cf", "political": "\u4e2d\u56fd\u5171\u4ea7\u515a\u515a\u5458", "education": "\u5927\u5b66\u672c\u79d1", "birthplace": "\u5c71\u4e1c\u7701\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u5b9d\u5c71\u9547\u4e0b\u67f4\u6751", "employer": "\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66", "position": "\u6559\u5e08", "positiontitle": "\u4e2d\u5b66\u9ad8\u7ea7\u6559\u5e08", "idnumber": "370223197111295333", "union": "\u9752\u5c9b\u5e02\u4f5c\u5bb6\u534f\u4f1a", "address": "\u5c71\u4e1c\u7701\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66", "telephone": "\u65e0", "email": "249707981@qq.com", "postcode": "266425", "wechat": "A15154281023", "officephone": "\u65e0", "mobile": "15154281023", "joindate_n": "", "joindate_p": "", "joindate_c": "", "mid_n": "", "mid_p": "", "mid_c": "", "posi_n": "", "posi_p": "", "posi_c": "", "photo": "", "intime": "2020-09-30 08:29:11", "status": "\u5f85\u5ba1\u6838", "memberid": "", "isdeleted": "0", "remark": "\u5165\u4f1a\u8981\u6c42\u5728\u5e02\u7ea7\u4ee5\u4e0a\u62a5\u520a\u6742\u5fd7\u53d1\u8868\u6587\u5b66\u4f5c\u54c1\u4e24\u7bc7\u4ee5\u4e0a\u6216\u8005\u83b7\u5f97\u5e02\u7ea7\u4ee5\u4e0a\u6587\u5b66\u5956\u9879\u3002" }
            // }
        })
        this.$axios.get('/api/wenlian/requestdetail', {
            params: {
                id: id,
                step: 2
            }
        }).then(res => {
            if (res.data.result == 1) {
                this.formData2 = res.data.data
            }
            // else {
            //   this.formData2 = { "awards": [{ "id": "125", "mid": "4359", "date": "2020-03", "place": "\u70df\u53f0\u5e02", "organizer": "\u5c71\u4e1c\u6563\u6587\u5b66\u4f1a", "press": "\u80f6\u4e1c\u6563\u6587\u5341\u4e8c\u5bb6\uff08\u7b2c\u4e09\u8f91\uff09", "awards": "\u53d1\u8868\u6563\u6587\u516d\u7bc7\uff0c\u83b72020\u5e74\u5ea6\u80f6\u4e1c\u6563\u6587\u4f18\u79c0\u4f5c\u54c1\u5956" }, { "id": "126", "mid": "4359", "date": "2020-05", "place": "\u70df\u53f0\u5e02", "organizer": "\u5c71\u4e1c\u6563\u6587\u5b66\u4f1a", "press": "\u80f6\u4e1c\u6563\u6587\u5e74\u9009", "awards": "\u53d1\u8868\u300a\u4e2d\u5e74\u4e4b\u60d1\u300b" }, { "id": "127", "mid": "4359", "date": "2012-11", "place": "\u897f\u6d77\u5cb8\u65b0\u533a", "organizer": "\u4e2d\u56fd\u6821\u5916\u6559\u80b2\u6742\u5fd7\u793e\u7f16\u8f91\u90e8", "press": "\u300a\u4e2d\u56fd\u6821\u5916\u6559\u80b2\u300b\u6742\u5fd7", "awards": "\u53d1\u8868\u300a\u6d45\u8c08\u5fb7\u80b2\u6559\u80b2\u7684\u5b9e\u65bd\u9014\u5f84\u300b" }, { "id": "695", "mid": "4359", "date": "2020-11", "place": "", "organizer": "", "press": "", "awards": "" }], "photos": [{ "id": "3645", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153429_680.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3646", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153552_581.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3647", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153558_531.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3648", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153609_993.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3649", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153618_471.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3650", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153625_707.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3651", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153642_880.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3652", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153649_337.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3653", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153703_718.jpg", "intime": "2021-09-23 15:38:17", "desc": null }] }
            // }
        })
        this.$axios.get('/api/wenlian/requestdetail', {
            params: {
                id: id,
                step: 3
            }
        }).then(res => {
            if (res.data.result == 1) {
                this.formData3 = res.data.data
            }
            // else {
            //   this.formData3 = [{ "id": "119", "mid": "4359", "startdate": "1993-07", "enddate": "", "exp": "\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66  \u4efb\u6559\u9ad8\u4e2d\u8bed\u6587" }]
            // }
        })
    }
}
</script>

<style lang="css" scoped>
.detail .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
    opacity: 0.5;
    background-color: #18a689;
    border-color: #18a689;
}

.detail .btn-primary {
    background-color: #18a689;
    border-color: #18a689;
    width: 200px;
}

.detail .btn-primary:hover {
    background-color: #1ab394;
    border-color: #1ab394;
}

.detail .btn-primary.disabled {
    opacity: 0.5;
    background-color: #18a689;
    border-color: #18a689;
}

.detail .red {
    color: red;
    margin: 0 5px;
}

.detail .step2 .custom-file-label::after {
    content: "证明材料上传";
    border-radius: 0.25rem;
    text-align: center;
    width: 100%;
    height: 100%;
}

.detail .step2 .custom-file-label {
    border: none;
}

.detail .step2 .red {
    color: red;
    margin: 0 5px;
}

.detail .step2 .sub-tit {
    color: #33434b;
    font-size: 16px;
    padding-left: 10px;
    margin-bottom: 15px;
}

.table-body {
    width: 1000px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    padding: 50px 0;
    margin-top: 20px;
}

.table-body table {
    width: 820px;
    border-collapse: collapse;
    font-size: 14px;
    table-layout: fixed;
}

.table-body table td {
    height: 60px;
    text-align: center;
    word-wrap: break-word;
    word-break: break-all;
}

.print-tips {
    width: 100%;
    padding: 20px;
    color: red;
}

@media print {

    .header,
    .buttons {
        display: none;
    }

    .print-tips {
        display: none;
    }

    .print-hidden {
        display: none !important;
    }
}

@page {
    margin: 0;
}

@media screen and (max-width: 750px) {}
</style>



// WEBPACK FOOTER //
// src/components/tableDetail.vue